import script from "./HelpSupportMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpSupportMobile.vue?vue&type=script&setup=true&lang=js"

import "./HelpSupportMobile.vue?vue&type=style&index=0&id=12b9ab2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b9ab2e"]])

export default __exports__